import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag, User } from "lucide-react";
import { navLinks } from "../mock/mock";

const Logo = () => (
  <Link to="/" className="flex items-center gap-3 group">
    <div className="relative w-14 h-14 rounded-full border-2 flex items-center justify-center bg-white shrink-0"
      style={{ borderColor: "var(--teal)" }}>
      <div className="absolute inset-1 rounded-full border" style={{ borderColor: "var(--gold)" }} />
      <div className="text-center leading-none">
        <div className="font-serif-display font-bold text-[13px] tracking-[0.15em] text-navy">BOSSY</div>
        <div className="text-[6px] tracking-[0.2em] text-navy mt-[2px]">KELLY &amp; KELLY</div>
      </div>
    </div>
  </Link>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-cream/95 backdrop-blur shadow-[0_4px_20px_-12px_rgba(22,38,63,0.4)]" : "bg-cream"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Logo />

        <div className="hidden xl:flex items-center gap-7">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`nav-link font-ui text-[15px] font-medium text-navy ${
                location.pathname === l.to ? "active" : ""
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <Link to="/login" className="hidden sm:flex items-center gap-2 text-navy font-ui text-sm font-medium hover:text-orange transition-colors">
            <User size={18} /> Log In
          </Link>
          <Link to="/shop" className="relative text-navy hover:text-orange transition-colors">
            <ShoppingBag size={22} />
          </Link>
          <button className="xl:hidden text-navy" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`xl:hidden overflow-hidden transition-all duration-300 bg-cream border-t ${
          open ? "max-h-[560px]" : "max-h-0"
        }`}
        style={{ borderColor: "var(--cream-dark)" }}
      >
        <div className="px-5 py-4 flex flex-col gap-1">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`font-ui py-3 px-2 rounded-md text-navy font-medium transition-colors ${
                location.pathname === l.to ? "bg-cream-dark text-orange" : "hover:bg-cream-dark"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <button className="mt-2 flex items-center gap-2 py-3 px-2 text-navy font-ui font-medium" onClick={() => { window.location.href = "/login"; }}>
            <User size={18} /> Log In
          </button>
        </div>
      </div>
    </header>
  );
}
